import { ref as p, reactive as z, computed as y, onMounted as H, nextTick as P, onBeforeUnmount as $, watch as l, createElementBlock as b, openBlock as k, normalizeClass as x, createElementVNode as B, renderSlot as S, createCommentVNode as A, normalizeStyle as D, unref as h } from "vue";
import { t as M } from "../vendor/tippy.js@6.3.7.js";
const I = {
  __name: "DTippy",
  props: {
    hoverable: {
      type: Boolean,
      description: "Show the content when hovering the trigger"
    },
    placement: {
      type: String,
      default: "bottom",
      description: "Where should the content be placed relative to the trigger",
      validator: (r) => [
        "bottom",
        "top",
        "left",
        "right",
        "top-start",
        "top-end",
        "bottom-start",
        "bottom-end",
        "left-start",
        "left-end",
        "right-start",
        "right-end"
      ].includes(r)
    },
    disabled: {
      type: Boolean,
      description: "Disables the component from being used (if applicable)"
    },
    distance: {
      type: String,
      default: "2",
      description: "Offset the content from the trigger using Tailwind spacing"
    },
    interactive: {
      type: Boolean,
      description: "Can the user interact with the content?"
    },
    selectable: {
      type: Boolean,
      description: "Used for dropdown selection"
    },
    animate: {
      type: Boolean,
      description: "Should the content show/hide with an animation"
    },
    arrow: {
      type: Boolean,
      description: "Should we show arrows pointing to the trigger"
    },
    active: {
      type: Boolean,
      description: "Manually control the visibility of the content, this does not work in the docs preview"
    },
    allowShrink: {
      type: Boolean,
      description: "Remove min width restriction"
    },
    manual: {
      type: Boolean,
      description: "Remove the ability to click/hover to show content"
    },
    hideOnClick: {
      type: Boolean,
      default: !0,
      description: "Should the content hide when user clicks anywhere"
    },
    inline: {
      type: Boolean,
      description: "Display the content inline with the page"
    },
    flex: Boolean
  },
  emits: ["show", "hide"],
  setup(r, { expose: f, emit: C }) {
    const m = C, e = r, n = p(null), d = p(null), s = p(null), v = p(null), i = z({
      x: 0,
      y: 0,
      z: 0
    }), E = y(() => e.manual ? "manual" : e.hoverable ? "mouseenter focus" : "click"), T = y(() => [0, parseInt(e.distance, 10) * 4]), u = () => {
      e.selectable && d.value && (e.allowShrink || (n.value.popper.style.minWidth = "300px"));
    }, g = (t) => {
      const a = s.value.clientWidth, c = s.value.clientHeight, o = t.clientWidth, w = t.clientHeight;
      switch (e.placement) {
        case "bottom-start":
        case "top-start":
          i.x = o / 2 - 6;
          break;
        case "bottom":
        case "top":
          i.x = a / 2 - 6;
          break;
        case "bottom-end":
        case "top-end":
          i.x = a - o / 2 - 6;
          break;
        case "right-start":
        case "left-start":
          i.y = w / 2 - 6;
          break;
        case "right":
        case "left":
          i.y = c / 2 - 6;
          break;
        case "right-end":
        case "left-end":
          i.y = c - w / 2 - 6;
          break;
        default:
          i.x = o / 2 - 6;
          break;
      }
    }, O = () => {
      n.value && n.value.setContent();
    }, W = () => {
      const t = s.value, a = d.value, c = e.animate;
      !t || !a || (s.value.remove(), n.value = M(a, {
        render(o) {
          return {
            popper: t
          };
        },
        trigger: E.value,
        placement: e.placement,
        offset: T.value,
        interactive: e.interactive,
        animation: e.animate,
        hideOnClick: e.hideOnClick,
        delay: 10,
        popperOptions: {
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                altAxis: !0
              }
            }
          ]
        },
        appendTo: () => a.closest("body"),
        onMount(o) {
          e.arrow && g(o.reference);
        },
        onShow(o) {
          clearInterval(v.value), e.selectable && u(), m("show");
        },
        onHide(o) {
          c && (v.value = setTimeout(() => {
            o.unmount();
          }, 10)), m("hide");
        },
        onAfterUpdate(o) {
          setTimeout(() => {
            e.arrow && g(o.reference);
          }, 1);
        }
      }), e.disabled && n.value.disable());
    };
    return H(() => {
      P(() => {
        W(), window.addEventListener("resize", u);
      });
    }), $(() => {
      window.removeEventListener("resize", u), n.value && n.value.destroy();
    }), l(() => e.trigger, (t) => {
      n.value.setProps({
        trigger: t
      });
    }), l(() => e.placement, (t) => {
      n.value.setProps({
        placement: t
      });
    }), l(() => e.offset, (t) => {
      n.value.setProps({
        offset: t
      });
    }), l(() => e.hideOnClick, (t) => {
      n.value.setProps({
        hideOnClick: t
      });
    }), l(() => e.interactive, (t) => {
      n.value.setProps({
        interactive: t
      });
    }), l(() => e.disabled, (t) => {
      n.value && (t ? n.value.disable() : n.value.enable());
    }), l(() => e.active, (t) => {
      n.value && (t ? n.value.show() : n.value.hide());
    }), f({
      updateContent: O,
      tip: n
    }), (t, a) => (k(), b("div", {
      class: x({ "w-full flex justify-center": r.inline, "w-full h-full flex-1 flex": r.flex })
    }, [
      B("div", {
        ref_key: "triggerEl",
        ref: d,
        "data-trigger": "",
        class: x({ "w-full flex justify-center": r.inline, "flex-1": r.flex })
      }, [
        S(t.$slots, "trigger")
      ], 2),
      B("div", {
        ref_key: "contentEl",
        ref: s
      }, [
        S(t.$slots, "default"),
        r.arrow ? (k(), b("div", {
          key: 0,
          ref: "arrow",
          class: "tippy-arrow",
          style: D([{ position: "absolute" }, { transform: `translate3d(${h(i).x}px, ${h(i).y}px, ${h(i).z}px)` }])
        }, null, 4)) : A("", !0)
      ], 512)
    ], 2));
  }
};
export {
  I as _
};
